
import React, { useState } from 'react';
import InputSelect from 'src/components/shared/Form/Select';

import {
    AddContainer, Component4, Texts, InputTextComponent,
    PrescriptionViewBox, PresText, PresTitle, EditButton, SaveButton, TwoButton, InnerTwoButtons
} from './Styles';
import { Formik, Form } from 'formik';
import {
    Box, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';

import theme from 'src/config/theme';
import { getUserFromToken } from 'src/DecodeToken';
import useResponsive from 'src/components/hooks/useResponsive';


const LinkStep = ({ innerRef, data, setDoctorProfileData, onSkip, onNext, onBack }) => {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '20px';
    const Height = isMobile || isTablet ? '18px' : '20px';

    const userId = getUserFromToken();

    const LinkTypes = [
        { label: 'Social Media', value: 'Social Media' },
        { label: 'Awards', value: 'Awards' },
        { label: 'New Media', value: 'New Media' },
        { label: 'Research Paper', value: 'Research Paper' },
        { label: 'Business Profiles', value: 'Business Profiles' },
        { label: ' Certificates', value: 'Certificates' },
        { label: 'Website', value: 'Website' },
        { label: 'Directions', value: 'Directions' },
        { label: 'Others', value: 'Others' },
    ]

    const Categories = [
        { label: 'Personal', value: 'Personal' },
        { label: 'Not Personal', value: 'Not-Personal' },
    ]
    const [selectedLink, setSelectedLink] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [localLinks, setLocalLinks] = useState(data || []);

    const initialValues = {
        type: selectedLink?.type || '',
        linkType: selectedLink?.linkType || '',
        linkTitle: selectedLink?.linkTitle || '',
        url: selectedLink?.url || '',
        user: userId || '',
    };

    const handleEdit = (links) => {
        setSelectedLink(links);
        setOpenDialog(true);
    };

    const handleDelete = (linksToDelete) => {
        const updatedLinks = localLinks.filter(
            f => !(f.type === linksToDelete.type && f.linkType === linksToDelete.linkType && f.linkTitle === linksToDelete.linkTitle && f.url === linksToDelete.url)
        );
        setLocalLinks(updatedLinks);
        setDoctorProfileData(prev => ({
            ...prev,
            links: updatedLinks,
        }));
    };
    const handleAdd = () => {
        setSelectedLink(null);
        setOpenDialog(true);
    };

    const handleSubmit = (values, { resetForm }) => {
        if (!values.type.trim() || !values.linkType.trim() || !values.linkTitle.trim() || !values.url.trim()) return;

        setLocalLinks(prev => {
            const isEditing = !!selectedLink;
            let updated;

            const newEntry = {
                type: values.type,
                linkType: values.linkType,
                linkTitle: values.linkTitle,
                url: values.url,
                user: values.user,
            };

            if (isEditing) {
                updated = prev.map(f =>
                    f.type === selectedLink.type &&
                        f.linkType === selectedLink.linkType &&
                        f.linkTitle === selectedLink.linkTitle &&
                        f.url === selectedLink.url
                        ? newEntry
                        : f
                );
            } else {
                const duplicate = prev.find(
                    f => f.type.trim().toLowerCase() === values.type.trim().toLowerCase() &&
                        f.linkType.trim().toLowerCase() === values.linkType.trim().toLowerCase() &&
                        f.linkTitle.trim().toLowerCase() === values.linkTitle.trim().toLowerCase() &&
                        f.url.trim().toLowerCase() === values.url.trim().toLowerCase()
                );
                if (duplicate) return prev;

                updated = [...prev, newEntry];
            }

            setDoctorProfileData(prevData => ({
                ...prevData,
                links: updated,
            }));

            return updated;
        });

        setSelectedLink(null);
        setOpenDialog(false);
        resetForm();
    };



    return (
        <>
            <AddContainer>
                {localLinks.map((links, index) => (
                    <PrescriptionViewBox key={index}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: '50%' }}>
                            <PresTitle>{links.type}</PresTitle>
                            <PresText>{links.linkType}</PresText>
                            <PresText>{links.linkTitle}</PresText>
                            <PresText sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                width: '300px !important',
                                display: 'block',
                            }}>{links.url}</PresText>

                        </Box>
                        <Box sx={{ display: 'flex', gap: '8px' }}>
                            <EditButton onClick={() => handleEdit(links)}>
                                <Edit width={Width} />
                            </EditButton>
                            <EditButton onClick={() => handleDelete(links)}>
                                <Close width={Width} />
                            </EditButton>
                        </Box>
                    </PrescriptionViewBox>
                ))}

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <SaveButton
                        variant="outlined"
                        startIcon={<Add width={Width} height={Height} sx={{ color: theme.palette.primary.main }} />}
                        onClick={handleAdd}
                    >
                        Add
                    </SaveButton>
                </Box>

            </AddContainer>

            <Dialog
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false);
                    setSelectedLink(null);
                }}
                maxWidth="md"
            >
                <DialogTitle>{selectedLink ? 'Edit Link' : 'Add New Link'}</DialogTitle>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={innerRef}

                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <DialogContent>
                                <AddContainer>
                                    <Component4>
                                        <Texts>Link Category</Texts>
                                        < InputSelect
                                            options={Categories}
                                            name="type"
                                            placeholder="Enter Link Type"
                                            variant="outlined"
                                            value={values.type}
                                            onChange={(value) => setFieldValue('type', value)}
                                            showNone={false}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>Link Type</Texts>
                                        < InputSelect
                                            options={LinkTypes}
                                            name="linkType"
                                            placeholder="Enter Link Type"
                                            variant="outlined"
                                            value={values.linkType}
                                            onChange={(value) => setFieldValue('linkType', value)}
                                            showNone={false}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>Link Title</Texts>
                                        < InputTextComponent
                                            name="linkTitle"
                                            placeholder="Enter link Title"
                                            variant="outlined"
                                            value={values.linkTitle}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>Link</Texts>
                                        <InputTextComponent
                                            name="url"
                                            placeholder="Enter Link Here"
                                            variant="outlined"
                                            value={values.url}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                </AddContainer>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                                <Button type="submit" variant="contained">
                                    {selectedLink ? 'Update' : 'Save'}
                                </Button>
                            </DialogActions>

                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default LinkStep;






















